<template>
    <div class="px-3 py-2">
        <v-form
            ref="forinv"
            lazy-validation
        >
        <b-sidebar id="add_category" aria-labelledby="sidebar-no-header-title" width="50%" no-header backdrop :style="`direction:`+$parent.lang.ldir" right :title="$parent.lang.add_category" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{$parent.lang.add_category}}</span>
                    </div>
                    <div @click="hide" id="iHideMe" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                    <span>{{$parent.lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <div class="px-3 py-2" style="direction:rtl">
                    <v-row>
                        <v-col cols="6">
                            <label>{{$parent.lang.category_name_ar}}</label>
                            <b-form-input class="inborder"
                                :label="$parent.lang.category_name_ar"
                                v-model="namear"
                                >{{ namear }}</b-form-input>
                        </v-col>
                        <v-col cols="6">
                            <label>{{$parent.lang.category_name_en}}</label>
                            <b-form-input class="inborder"
                                :label="$parent.lang.category_name_en"
                                v-model="nameen"
                                >{{ nameen }}</b-form-input>
                        </v-col>
                        <v-col cols="6">
                            <label>{{$parent.lang.product_categories}}</label>
                            <!-- A picker rather than a plain select: installs with
                                 thousands of categories cannot render them all. -->
                            <searchable-select
                                v-model="parentid"
                                :items="parentOptions"
                                :selected-text="parentText"
                                :loading="loadingParents"
                                :placeholder="catLabels.type_to_search"
                                :loading-text="catLabels.searching"
                                :empty-text="catLabels.no_results"
                                :hint="parentHint"
                                @search="searchParents"
                                @picked="onParentPicked"
                            />
                        </v-col>
                        <v-col cols="6">
                            <label>{{$parent.lang.type}}</label>
                                <b-input-group>
                                <b-form-select class="selborder"
                                    v-model="type"
                                    :options="types"
                                    :label="$parent.lang.type"
                                ></b-form-select>
                                <b-input-group-addon style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                </b-input-group-addon>
                            </b-input-group>
                        </v-col>
                        <v-col cols="6">
                            <label>{{catLabels.show_in_pos}}</label>
                            <b-input-group>
                                <b-form-select class="selborder"
                                    v-model="show_in_pos"
                                    :options="posOptions"
                                    :label="catLabels.show_in_pos"
                                ></b-form-select>
                                <b-input-group-addon style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                </b-input-group-addon>
                            </b-input-group>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="addcat()" hide id="addBTN" variant="success" class="ma-2 btn-sm" style="width:130px;">{{$parent.lang.add}} / {{$parent.lang.update}}</b-button>
                </div>
            </template>
        </b-sidebar>
        </v-form>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
import SearchableSelect from '@/components/searchable-select.vue';
export default {
    components: { SearchableSelect },
    data() {
        return {
            namear: '',
            nameen: '',
            parentid: 0,
            parentText: '',
            type: 1,
            show_in_pos: 1,
            id: 0,
            product_categories: [],
            loadingParents: false,
            parentTotal: 0,
            parentPageSize: 10,
            types: [
                {
                    text: this.$parent.lang.main_cat,
                    value: 0
                },
                {
                    text: this.$parent.lang.sub_cat,
                    value: 1
                }
            ],
        }
    },
    created() {
        this.searchParents('');
    },
    computed: {
        catLabels(){
            const lang = this.$parent.lang || {};
            return {
                show_in_pos: lang.show_in_pos || 'Show on POS',
                type_to_search: lang.type_to_search || 'Type to search...',
                searching: lang.searching || '...',
                no_results: lang.no_results || 'No results',
                showing_first: lang.showing_first || 'Showing first',
                of: lang.of || 'of',
                yes: lang.yes || 'Yes',
                no: lang.no || 'No',
            }
        },
        posOptions(){
            return [
                { text: this.catLabels.yes, value: 1 },
                { text: this.catLabels.no, value: 0 },
            ]
        },
        parentOptions(){
            // "Main category" is always offered as the root option.
            return [{ text: this.$parent.lang.main_cat, value: 0 }].concat(this.product_categories);
        },
        parentHint(){
            if(this.parentTotal > this.parentPageSize){
                return `${this.catLabels.showing_first} ${this.parentPageSize} ${this.catLabels.of} ${this.parentTotal}`;
            }
            return '';
        },
    },
    methods: {
        changeType(type){
            this.type = type;
        },
        /**
         * Sets the selected parent together with the label to show for it. The
         * label has to be passed in because the chosen row is usually not in the
         * ten results the picker is holding.
         */
        setParent(id, text){
            this.parentid = id || 0;
            this.parentText = (id && text) ? text : this.$parent.lang.main_cat;
            if(id && !text){
                this.resolveParentName(id);
            }
        },
        onParentPicked(item){
            this.parentText = item.text;
        },
        resolveParentName(id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPCats');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]','all');
            post.append('data[ids]',id);
            post.append('data[lang]',this.$parent.lang.langname);
            axios.post(this.$SAMCOTEC.r_path,post)
            .then((response) => {
                const rows = (response.data.results && response.data.results.data) || [];
                if(rows.length){
                    this.parentText = this.$parent.lang.langname == "ar" ? rows[0].namear : rows[0].nameen;
                }
            });
        },
        addcat() {
            if(this.nameen == '' && this.namear == ''){
                let message = this.$parent.lang.add_arabic_section_name_required;
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            else if(this.nameen != '' && this.namear == ''){
                this.namear = this.nameen
            }
            else if(this.namear != '' && this.nameen == ''){
                this.nameen = this.namear
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','addUpdateCat');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[lang]',this.$parent.lang.langname);
            post.append('data[id]',this.id);
            post.append('data[namear]',this.namear);
            post.append('data[nameen]',this.nameen);
            post.append('data[parentid]',this.parentid);
            post.append('data[type]',this.type);
            post.append('data[show_in_pos]',this.show_in_pos);
            axios.post(this.$SAMCOTEC.r_path,post)
            .then(() => {
              this.$parent.getCats();
              this.searchParents('');
              this.ihide()
                            let message = this.$parent.lang.addes_successfuly;
                                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            });
        },
        ihide(){
            document.getElementById('iHideMe').click();
        },
        /**
         * Only main categories can be a parent, and only ten at a time - the
         * rest are reached by typing.
         */
        searchParents(term){
            this.loadingParents = true;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPCats');
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]','0');
            post.append('data[limit]',this.parentPageSize);
            post.append('data[cpage]',0);
            post.append('data[search]',term || '');
            post.append('data[lang]',this.$parent.lang.langname);

            axios.post(this.$SAMCOTEC.r_path,post)
            .then((response) => {
                this.loadingParents = false;
                const results = response.data.results || {};
                const rows = results.data || [];
                this.parentTotal = parseInt(results.allres || 0);

                let t = [];
                for(let i=0;i<rows.length;i++){
                    // Never offer a category as its own parent.
                    if(this.id && rows[i].id == this.id) continue;
                    t.push({
                        text: this.$parent.lang.langname == "ar" ? rows[i].namear : rows[i].nameen,
                        value: rows[i].id
                    })
                }
                this.product_categories = t;
            })
            .catch(() => {
                this.loadingParents = false;
            });
        }
    },

}
</script>
